import ForumDetail from './ForumDetail';

export default ForumDetail;
